module.exports = __webpack_public_path__ + "img/apple.7151b1e1.svg";